export default __webpack_public_path__ + "static/SpaceGrotesk-Light-ba15429f9efcccc2826ad5f276b096fa.ttf";